import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useEffect, useState } from 'react'
import Spinner from '../../components/spinner'
import { Artist, Track, useAudioPlayer } from '../../components/audioPlayer/provider'
import { Button, Card, CardActionArea, CardContent, Grid, Typography } from '@iziplay/ui-kit'
import { PlayArrow } from '@nine-thirty-five/material-symbols-react/sharp/filled'
import { AlbumCover } from '../../components/albumCover'


export function MusicArtist() {
  const params = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [artist, setArtist] = useState<Artist | undefined>()

  const { setPlaylistPlayId } = useAudioPlayer()

  const fetchArtist = async () => {
    const res = await axios.request({
      method: 'GET',
      url: `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${params.artist}`
    })
    setArtist(res.data.artist)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchArtist()
  }, [])

  if (isLoading) {
    return <Spinner />
  }

  if (!artist) {
    return <p>Cannot get artist</p>
  }

  return (
    <div className="scrollable" style={{ display: 'flex', flexDirection: 'column', padding: '12px' }}>
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: '20px', margin: '14px' }}>
          <AlbumCover
            src={`${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${artist!.id}/artwork?size=400`}
            title={artist.name}
            style={{ width: 300, height: 300, borderRadius: '150px', flexShrink: 0 }}
          />
          <div style={{ display: 'flex', padding: '40px 20px 0px 20px', flexDirection: 'column' }}>
            <Typography variant="h5" style={{ fontWeight: 'bold' }}>{artist.name}</Typography>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', paddingTop: '10px' }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PlayArrow size={24} />}
                onClick={() => {
                  const tracks = artist.releases?.map(release => release.media?.map(medium => medium.tracks.map(track => ({ ...track, artist, release, url: `${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${artist.id}/release/${release.id}/medium/${medium.id}/position/${track.position}/file` }))).flat()).flat()
                    ?.filter(track => Boolean(track)) as Track[]
                  if (tracks.length > 0) {
                    console.log('setplay', tracks, tracks[0].id)
                    setPlaylistPlayId(tracks, tracks[0].id)
                  }
                }}
              >
                Play everything
              </Button>
            </div>
          </div>
        </div>
        <Grid container spacing={1}>
          {artist.releases?.map(release => (
            <Grid key={release.id} size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
              <Card variant="outlined">
                <CardActionArea
                  to={`/music/${artist.id}/${release.id}`}
                >
                  <AlbumCover
                    src={`${(import.meta.env.REACT_APP_IZIPLAY_URL_MUSIC as string)}/artist/${artist.id}/release/${release.id}/artwork?size=360`}
                    title={`Cover of ${release.name} by ${artist.name}`}
                  />
                  <CardContent>
                    <Typography variant="body1" component="h2" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                      {release.name}
                    </Typography>
                    {release.year && (
                      <Typography variant="body2" color="textSecondary" component="p" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {release.year}
                      </Typography>
                    )}
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  )
}
